import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const DEFAULT_SITE_URL = process.env.REACT_APP_SITE_URL || 'https://betonoki.pl';

function absolutizeUrl(urlOrPath, origin) {
  if (!urlOrPath) return '';
  if (/^https?:\/\//i.test(urlOrPath)) return urlOrPath;
  if (urlOrPath.startsWith('//')) return `https:${urlOrPath}`;
  if (urlOrPath.startsWith('/')) return `${origin}${urlOrPath}`;
  return `${origin}/${urlOrPath}`;
}

export default function Seo({
  title,
  description,
  path,
  image = '/img/logo.png',
  noindex = false,
}) {
  const { i18n } = useTranslation();
  const lang = (i18n?.language || 'pl').split('-')[0];

  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : DEFAULT_SITE_URL;

  const canonicalPath =
    path ||
    (typeof window !== 'undefined' && window.location?.pathname
      ? window.location.pathname
      : '/');

  const canonicalUrl = absolutizeUrl(canonicalPath, origin);
  const ogImageUrl = absolutizeUrl(image, origin);

  return (
    <Helmet>
      <html lang={lang} />
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}

      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:url" content={canonicalUrl} />
      {ogImageUrl ? <meta property="og:image" content={ogImageUrl} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      {ogImageUrl ? <meta name="twitter:image" content={ogImageUrl} /> : null}

      {noindex ? <meta name="robots" content="noindex,nofollow" /> : null}
    </Helmet>
  );
}

